import Auth from "front-component/Auth";
import BaseUserModule, { User as BaseUser, Department as BaseDepartment } from "front-component/modules/User";
import EventBus from "front-component/EventBus";
import UserRepository from "@/repositories/UserRepository";

BaseUserModule.actions = {
    fetchCurrentUserData: ({ commit }: any) => {
        return new Promise((resolve: (value: boolean) => void, reject: (value: object) => void) => {
            const accessToken: string | null = Auth.getAccessToken();
            if (!accessToken) {
                return reject({error: "No token provided"});
            }
            const params = {
                filters: {
                    me: true,
                    unique: true,
                }
            };
            UserRepository.get(params).then((user: object) => {
                commit("setCurrentUser", user);
                resolve(true);
            }).catch((reason) => {
                EventBus.$emit("error-alert", { message: reason });
            });
        });
    },
};

export default BaseUserModule;
export interface User extends BaseUser {
    isBiSync: boolean;
    socleApprover: boolean;
}
export type Department = BaseDepartment;
